import React from "react";
import classNames from "classnames";
import i18next from "i18next";

export interface IDrawingButton {
    onClick: () => void;
    color: string;
    disabled?: boolean;
}

export const ColorButton = ({ onClick, disabled, color }: IDrawingButton): JSX.Element => (
    <div
        className={classNames("widget-toolbar-button", "color-button", { disabled })}
        onClick={onClick}
        title={i18next.t("sketch.chooseColor")}
    >
        <span style={{ backgroundColor: color }} />
    </div>
);
